export const FAVORITE_TEAM = {
  CPBL_CTBC: 'CPBL_CTBC',
  CPBL_FUBON: 'CPBL_FUBON',
  CPBL_HAWKS: 'CPBL_HAWKS',
  CPBL_RAKUTEN: 'CPBL_RAKUTEN',
  CPBL_UNI: 'CPBL_UNI',
  CPBL_WEICHUAN: 'CPBL_WEICHUAN',
  CHEERLEADER: 'CHEERLEADER',
};

export const FAVORITE_TEAM_TEXT = {
  [FAVORITE_TEAM.CPBL_CTBC]: '中信兄弟',
  [FAVORITE_TEAM.CPBL_FUBON]: '富邦悍將',
  [FAVORITE_TEAM.CPBL_HAWKS]: '台鋼雄鷹',
  [FAVORITE_TEAM.CPBL_RAKUTEN]: '樂天桃猿',
  [FAVORITE_TEAM.CPBL_UNI]: '統一7-ELEVEn獅',
  [FAVORITE_TEAM.CPBL_WEICHUAN]: '味全龍',
  [FAVORITE_TEAM.CHEERLEADER]: '啦啦隊',
};

export const FAVORITE_TEAM_ABBR = {
  [FAVORITE_TEAM.CPBL_CTBC]: '中信',
  [FAVORITE_TEAM.CPBL_FUBON]: '富邦',
  [FAVORITE_TEAM.CPBL_HAWKS]: '台鋼',
  [FAVORITE_TEAM.CPBL_RAKUTEN]: '樂天',
  [FAVORITE_TEAM.CPBL_UNI]: '統一',
  [FAVORITE_TEAM.CPBL_WEICHUAN]: '味全',
  [FAVORITE_TEAM.CHEERLEADER]: '啦啦',
};

export const FAVORITE_TEAM_COLOR = {
  [FAVORITE_TEAM.CPBL_CTBC]: '#f4cf46;#000000',
  [FAVORITE_TEAM.CPBL_FUBON]: '#204e93;#fefefe',
  [FAVORITE_TEAM.CPBL_HAWKS]: '#1e4639;#fefefe',
  [FAVORITE_TEAM.CPBL_RAKUTEN]: '#671a19;#fefefe',
  [FAVORITE_TEAM.CPBL_UNI]: '#dd732c;#fefefe',
  [FAVORITE_TEAM.CPBL_WEICHUAN]: '#bd2e34;#fefefe',
  [FAVORITE_TEAM.CHEERLEADER]: '#FFC7ED;#000000',
};
